var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyChatsIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 100,
    viewBox: "0 0 175 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.4395,
    cy: 42.3283,
    rx: 42.5,
    ry: 42.3283,
    fill: "#F0F9FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.407 97.8041V24.3679L115.338 58.1675L159.407 97.8041Z",
    fill: "#BBDFF5",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8174 24.3679V97.8041L92.7091 58.0706L51.8174 24.3679Z",
    fill: "#BBDFF5",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.338 58.1675L103.681 67.1071L92.7092 58.0706L51.8174 97.8041H159.407L115.338 58.1675Z",
    fill: "#BBDFF5",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.681 67.1071L115.338 58.1675L159.407 24.3679H51.8174L92.7092 58.0706L103.681 67.1071Z",
    fill: "#BBDFF5",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2783 59.874H2.38815C1.58654 59.874 0.939453 60.5236 0.939453 61.3284C0.939453 62.1331 1.58654 62.7828 2.38815 62.7828H47.288C48.0896 62.7828 48.7367 62.1331 48.7367 61.3284C48.727 60.5236 48.0799 59.874 47.2783 59.874Z",
    fill: "#BBDFF5",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2782 77.5786H11.2251C10.4235 77.5786 9.77637 78.2282 9.77637 79.033C9.77637 79.8377 10.4235 80.4874 11.2251 80.4874H47.2782C48.0798 80.4874 48.7269 79.8377 48.7269 79.033C48.7269 78.2282 48.0798 77.5786 47.2782 77.5786Z",
    fill: "#BBDFF5",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2782 42.1209H11.2251C10.4235 42.1209 9.77637 42.7705 9.77637 43.5753C9.77637 44.38 10.4235 45.0297 11.2251 45.0297H47.2782C48.0798 45.0297 48.7269 44.38 48.7269 43.5753C48.7269 42.7705 48.0798 42.1209 47.2782 42.1209Z",
    fill: "#BBDFF5",
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 151.035,
    cy: 29.7385,
    r: 19.5425,
    fill: "#FD9E8A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 154.517,
    cy: 29.7385,
    r: 19.5425,
    stroke: "#6A79A8",
    strokeWidth: 1.2906,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.004 39.4564C149.635 39.4506 148.465 39.0868 147.495 38.365C146.524 37.6432 145.782 36.5925 145.268 35.213C144.754 33.8334 144.497 32.1715 144.497 30.2273C144.497 28.2889 144.754 26.6329 145.268 25.2591C145.788 23.8854 146.533 22.8376 147.503 22.1158C148.48 21.394 149.646 21.0331 151.004 21.0331C152.361 21.0331 153.525 21.397 154.495 22.1246C155.466 22.8464 156.208 23.8941 156.722 25.2679C157.242 26.6358 157.502 28.2889 157.502 30.2273C157.502 32.1773 157.245 33.8421 156.731 35.2217C156.217 36.5954 155.474 37.6461 154.504 38.3737C153.534 39.0955 152.367 39.4564 151.004 39.4564ZM151.004 37.1251C152.205 37.1251 153.144 36.5343 153.82 35.3527C154.501 34.171 154.842 32.4626 154.842 30.2273C154.842 28.743 154.686 27.4886 154.374 26.4641C154.068 25.4338 153.626 24.6538 153.048 24.1241C152.477 23.5885 151.795 23.3208 151.004 23.3208C149.808 23.3208 148.87 23.9145 148.188 25.102C147.506 26.2895 147.163 27.9979 147.157 30.2273C147.157 31.7175 147.31 32.9777 147.616 34.008C147.928 35.0325 148.37 35.8096 148.942 36.3393C149.514 36.8632 150.201 37.1251 151.004 37.1251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChatsIcn);
export default __webpack_public_path__ + "static/media/empty-chats-icn.7ccd4003acf452e85fd90588e0559b8b.svg";
export { ForwardRef as ReactComponent };